export default {
  getListOptionsOffers: state => state.listOptionsOffers,
  getRulesOffers: state => state.rulesOffers,
  getOffersSelecteds: state => state.offersSelecteds,
  getParamsFilter: state => state.paramsFilter,
  getFilterCampaignSelecteds: state => state.filterCampaignSelecteds
}
